export default { version: 'development' };
